const ConstantData = {
  legendDefaultKeys: [
    {
      color: "#ddad01",
      label: "REITS",
    },
    {
      color: "#9660c9",
      label: "Large Ops",
    },
    {
      color: "#fc8472",
      label: "Mid Ops",
    },
    {
      color: "#844204",
      label: "Small Ops",
    },
    {
      color: "#38a83c",
      label: "Single Ops",
    },
  ],
  lookupKeyMap : {
    "free": 1,
    "annually": 3,
    "quarterly": 7,
    "singleReport": 4,
    "fiveReport": 8,
    "tenReport": 5,
  },
  radiusMaxCount: 100,
  otpSettings: { totalOTPLength: 6, resendWaitingSec: 20 , sessionWaitingSec : 15 },
  severityMap: {
    200: "success",
    400: "error",
    401: "error",
    404: "error",
    500: "warning",
  },
  excelHeader: {
    rvparks: "RV Parks",
    geodetails: "Geo Details",
    amenities: "Amenities",
    rentaldetail: "Rental Details",
    ownerdetail: "Owner Details",
    loandetail: "Loan Details",
    managementdetail: "Management Detail",
    seasonaldata: "Seasonal Details",
  },
  excelRowHeader: {
    profileid: "Profile ID",
    profilename: "Profile Name",
    facilitytypes: "Facility Types",
    ownership: "Ownership",
    streetaddress1: "Street Address 1",
    streetaddress2: "Street Address 2",
    city: "City",
    statecode: "State Code",
    countryname: "Country Name",
    zipcode: "Zip Code",
    noofsites: "Number of Sites",
    padtype: "Pad Type",
    yearopened: "Year Opened",
    locationdescription: "Location Description",
    website: "Website",
    phone: "Phone",
    fax: "Fax",
    tollfree: "Toll-Free",
    email: "Email",
    facebook: "Facebook",
    instagram: "Instagram",
    rating: "Rating",
    seasonalityname: "Seasonality Name",
    landsize: "Land Size",
    countyname: "County Name",
    countyurl: "County URL",
    iskoa: "Is KOA",
    operatortype: "Operator Type",
    profileclass: "Profile Class",
    onlinebookingstatus: "Online Booking Status",
    latitude: "Latitude",
    longitude: "Longitude",
    glamping: "Glamping",
    rvparkstartdate: "RV Park Start Date",
    rvparkenddate: "RV Park End Date",
    proximity: "Proximity (Miles)",
    ishome: "Is Home",
    ownershiptype: "Ownership Type",
    aceragefields: "Acreage Fields",
    locationmap: "Location Map",
    additionallodging: "Additional Lodging",
    attractionsdescriptions: "Attractions Descriptions",
    backin: "Back-In",
    beachaccess: "Beach Access",
    cafe: "Cafe",
    cabins: "Cabins",
    cellphoneconnectivity: "Cellphone Connectivity",
    dogparks: "Dog Parks",
    dumpstation: "Dump Station",
    eatwentyamp: "20 AMP",
    twentyamp: "20 AMP",
    ebthirtyamp: "30 AMP",
    thirtyamp: "30 AMP",
    ecfiftyamp: "50 AMP",
    fiftyamp: "50 AMP",
    firering: "Fire Ring",
    fishing: "Fishing",
    gameroomarcade: "Game Room Arcade",
    golfcartrentals: "Golf Cart Rentals",
    hookups: "Hookups",
    internetconnectivity: "Internet Connectivity",
    internetconnectivitypayment: "Internet Connectivity Payment",
    lakeside: "Lakeside",
    laundryaccess: "Laundry Access",
    onsitepropane: "Onsite Propane",
    petallowed: "Pet Allowed",
    picnictable: "Picnic Table",
    pullinpullthrough: "Pull-In / Pull-Through",
    rechall: "Rec Hall",
    selfservicecarwash: "Self-Service Car Wash",
    sewerhookup: "Sewer Hookup",
    showersandbathrooms: "Showers and Bathrooms",
    sitelockers: "Site Lockers",
    sportscourts: "Sports Courts",
    swimmingpool: "Swimming Pool",
    tentcamping: "Tent Camping",
    vehicularaccess: "Vehicular Access",
    waterhookup: "Water Hookup",
    rvsitedailypernight: "RV Site Daily Per Night",
    rvsiteweekly: "RV Site Weekly",
    rvsitemonthly: "RV Site Monthly",
    tentsitedailypernight: "Tent Site Daily Per Night",
    tentsiteweekly: "Tent Site Weekly",
    tentsitemonthly: "Tent Site Monthly",
    cabindailypernight: "Cabin Daily Per Night",
    cabinweekly: "Cabin Weekly",
    cabinmonthly: "Cabin Monthly",
    discountclubs: "Discount Clubs",
    discountdetail: "Discount Detail",
    bookingenginename: "Booking Engine Name",
    bookingengineurl: "Booking Engine URL",
    bookingform: "Booking Form",
    bookingphone: "Booking Phone",
    bookingemail: "Booking Email",
    checkin: "Check-In",
    checkout: "Check-Out",
    companyphone: "Company Phone",
    companyemail: "Company Email",
    companyname: "Company Name",
    firstname: "First Name",
    lastname: "Last Name",
    title: "Title",
    ownerphone: "Owner Phone",
    owneremail: "Owner Email",
    loanamount: "Loan Amount ($)",
    loanmaturitydate: "Loan Maturity Date",
    loanoriginationdate: "Loan Origination Date",
    loantype: "Loan Type",
    interestrate: "Interest Rate",
    interesttype: "Interest Type",
    loanduration: "Loan Duration",
    landvalue: "Land Value ($)",
    improvementvalue: "Improvement Value ($)",
    marketvalue: "Market Value ($)",
    totalmarketvalue: "Total Market Value ($)",
    lastsaledate: "Last Sale Date",
    lastsalevalue: "Last Sale Value ($)",
    parcelid: "Parcel ID",
    status: "Status",
    managementphone: "Management Phone",
    managementemail: "Management Email",
    electriclevehiclecharging: "EV Charging",
    ownercompanyphone: "Owner Company Phone",
    ownercompanyemail: "Owner Company Email",
    ownerstreetaddress1: "Owner Street Address 1",
    ownerstreetaddress2: "Owner Street Address 2",
    ownercity: "Owner City",
    ownerstate: "Owner State",
    ownercountry: "Owner Country",
    ownerzipcode: "Owner Zip Code",
    ownerfax: "Owner Fax",
    ownertollfree: "Owner Toll-Free",
    ownerwebsite: "Owner Website",
    ownerfirstname: "Owner First Name",
    ownerlastname: "Owner Last Name",
    ownertitle: "Owner Title",
    season: "Season",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    rvprofileid: "Profile ID",
    valueyear: "Value Year",
  },
  totalAmenitiesCount: 37,
  excludedData: {
    rvparks: [
      "latitude",
      "longitude",
      "glamping",
      "electriclevehiclecharging",
      "landsize",
    ],
    seasonaldata: ["profileid"],
  },
  paymenttype: [
    { id: 1, name: "online" },
    { id: 2, name: "offline" },
    { id: 3, name: "custom" },
  ],
  devtypeid: {
    typeid: [11, 12, 13, 14, 15, 16, 21],
  },
advancedMapOverlaysIds : {
  fema : 18 ,
  eoz : 19,
  traffic : 20 ,
  none : 17,
  trafficZoomLevel : 10,
  showingPinsZoomLevel : 5,
  totalTrafficLogBins:14,
  trafficSplitIndicesWithZero: [[0, 1], [2], [3, 4], [5, 6], [7, 8], [9, 10], [11, 12, 13]],
  Ranges : [
  { value: 0, i: 0 },
  { value: 50, i: 0 },
  { value: 150, i: 0 },
  { value: 400, i: 1 },
  { value: 1000, i: 1 },
  { value: 3000, i: 1 },
  { value: 8000, i: 2 },
  { value: 15000, i: 2 },
  { value: 22000, i: 2 },
  { value: 40000, i: 3 },
  { value: 60000, i: 3 },
  { value: 100000, i: 4 },
  { value: 150000, i: 4 },
  { value: 220000, i: 4 },
  { value: 300000, i: 4 },
  { value: 500000, i: 4 },
  { value: Infinity, i: 4 },
]
},
  spotsInMarket:{min:1,max:2050},
  RateLimitErrorMessage : "You have exceeded your allowed request limit. Please try again later."

};


export default ConstantData;
